import { Error } from 'components/error'
import { language } from 'index'
import React from 'react'
import i18n from "../../i18n";
interface IInfoPage {
  handleClick: () => void
}
const InfoPage: React.FC<IInfoPage>  = (props: IInfoPage) => {
  const { handleClick } = props
  const countryCode = ["id", "en"]
  return (
    <React.Fragment>
    <Error
        imagePath={countryCode?.includes(language as string) ? '/mascot_generic_error.svg': null} 
        header={i18n.t("notEligibleDeleteHeader")}
        subheader={
          <React.Fragment>
            {i18n.t("notEligibleDeleteSubHeader")}
          </React.Fragment>
        }
        btnAction={i18n.t("closeButton")}
        handleReload={handleClick}
        withButton
      />
    </React.Fragment>
  )
}

export default InfoPage
